<template>
  <span>
    <template v-if="task.thirdOrganizationTask != null">
      <slot
        name="btn"
        v-if="task.thirdOrganizationTask.objectTypeId == 340"
      ></slot>
      <!-- <Button @click="init()" size="small" type="success" >{{btnTxt}}</Button> -->
    </template>
    <b-modal
      :transition-names="[]"
      title="Баталгаажуулах"
      footer-hide
      v-model="mdlShow"
      width="800"
      size="lg"
      hide-footer
      @hide="visibleChange"
    >
      <div
        :key="prntKey"
        ref="printArea"
        v-if="
          (examRegistrationTask.objectTypeId == 340 &&
            profData.colorCls != '' &&
            profData.colorCls != null) ||
            hasPermission(['learningadmin'])
        "
      >
        <table class="table w-full table-god table-bordered" cellspacing="0">
          <tbody>
            <tr>
              <td colspan="2" width="50%">Бүртгэлийн хуудас</td>
              <td width="50%">Анхааруулга</td>
            </tr>
            <tr>
              <td style="vertical-align:top">
                Код: {{ profData.colorCls }}
                <br />
                Овог: {{ profData.lastName }}
                <br />
                Нэр: {{ profData.firstName }}
                <br />
                <img id="dsfgsdgsdfsdf" :src="bse64" style="width: 120px" />
              </td>
              <td style="vertical-align:top">
                <img :src="profData.avator + '?w=80'" />
              </td>
              <td>
                1. Та шалгалтад хэрэглэгдэх тооны машинтай ирнэ үү
                <br />2. Та шалгалтанд утасгүй буюу утсаа унтрааж орно уу. /Утас
                ашиглах, дуу гарсан тохиолдолд шалгалтын оноог 0-лэх болохыг
                анхаарна уу/. <br />3. Шалгалтанд тарааж өгсөн харандааг ашиглах
                тул ширээн дээр илүү үзэг бал байлгахгүй байх <br />4. Шалгалтад
                заасан хугацаанд ороогүй тохиолдолд төлбөр буцаагдахгүй болохыг
                анхаарна уу
                <br />
              </td>
            </tr>
          </tbody>
        </table>

        <div
          v-if="
            hasPermission(['learningadmin']) &&
              (profData.colorCls == '' || profData.colorCls == null)
          "
        >
          <Form :model="profileModel" :label-width="160" class="p-sm">
            <template v-if="$store.state.user.groupId == 6126">
              <FormItem label="Мэргэшсэн нягтлан бодогч">
                <RadioGroup v-model="profileModel.i1">
                  <Radio :label="1">
                    <span>Тийм</span>
                  </Radio>
                  <Radio :label="0">
                    <span>Үгүй</span>
                  </Radio>
                </RadioGroup>
                <!-- <Checkbox v-model="submitModel.isTender"></Checkbox> -->
              </FormItem>
            </template>
            <template v-if="$store.state.user.groupId == 9157">
              <FormItem label="ACCA">
                <RadioGroup v-model="profileModel.i4">
                  <Radio :label="1">
                    <span>Тийм</span>
                  </Radio>
                  <Radio :label="0">
                    <span>Үгүй</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="Татварын мэргэшсэн зөвлөх">
                <RadioGroup v-model="profileModel.i5">
                  <Radio :label="1">
                    <span>Тийм</span>
                  </Radio>
                  <Radio :label="0">
                    <span>Үгүй</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </template>
            <template v-if="$store.state.user.groupId == 6126">
              <FormItem label="Татварын улсын байцаагч">
                <RadioGroup v-model="profileModel.i2">
                  <Radio :label="1">
                    <span>Тийм</span>
                  </Radio>
                  <Radio :label="0">
                    <span>Үгүй</span>
                  </Radio>
                </RadioGroup>
                <!-- <Checkbox v-model="submitModel.isTender"></Checkbox> -->
              </FormItem>
              <FormItem label="Нягтлан бодогч">
                <RadioGroup v-model="profileModel.i3">
                  <Radio :label="1">
                    <span>Тийм</span>
                  </Radio>
                  <!-- <Radio :label="0">
              <span>Үгүй</span>
                  </Radio>-->
                </RadioGroup>
                <!-- <Checkbox v-model="submitModel.isTender"></Checkbox> -->
              </FormItem>
            </template>
          </Form>
          <div class="text-center p-sm">
            <Button @click="saveProfileData" type="success">Хадгалах</Button>
          </div>
        </div>
        <Button
          v-if="
            hasPermission(['learningadmin']) &&
              (profData.colorCls == '' || profData.colorCls == null)
          "
          @click="acceptInvoice(taskId)"
          type="success"
          >Баталгаажуулах</Button
        >
        <Button @click="print" v-if="examRegistrationTask.objectTypeId == 340"
          >Хэвлэх</Button
        >

        <h3>Шалгалт</h3>
        <table class="table w-full table-god table-bordered" cellspacing="0">
          <thead>
            <tr>
              <th rowspan="2">Хичээлийн нэр</th>
              <th colspan="6">Өгөх шалгалт</th>
              <th colspan="2">Хөнгөлөлт авсан эсэх</th>
              <th rowspan="2">Комиссын гарын үсэг</th>
            </tr>
            <tr>
              <th>Шалгалт өгөх өдөр</th>
              <th>Эхлэх цаг</th>
              <th>Үргэлжлэх хугацаа</th>
              <th>Шалгалтын оноо</th>
              <th>Журам</th>
              <th>Журам</th>
              <th>Хэзээ</th>
              <th>Оноо</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(exam, i) in selectedExams" :key="i">
              <td>{{ exam.task }}</td>
              <td>{{ exam.dueStartDate | moment("YYYY.MM.DD") }}</td>
              <td>{{ exam.dueStartDate | moment("HH:mm") }}</td>
              <td style="text-align: right">{{ exam.st1 }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="width: 90px">
                {{ getHighPointDate(exam) | moment("YYYY.MM.DD") }}
              </td>
              <td>{{ getHighPoint(exam) }}</td>
              <td></td>
            </tr>
            <tr>
              <td colspan="10">
                <b>
                  Шалгалт:
                  <span v-html="examRegistrationTask.st2"></span>
                </b>
              </td>
            </tr>
            <tr>
              <td colspan="10">
                <span v-html="examRegistrationTask.st3"></span>
              </td>
            </tr>
            <tr>
              <td colspan="10">
                <b>Бүртгэсэн:</b>
                <span v-html="examRegistrationTask.st4"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="examRegistrationTask.objectTypeId == 115">
        <div v-if="localTask.isTender">Таны төлбөр баталгаажсан байна.</div>
        <div v-else>
          <div>
            Таны төлбөр баталгаажаагүй байна энд дарж төлбөр төлөх эсвэл
            нэхэмжлэх авна уу.
          </div>
          <button
            type="button"
            class="ivu-btn ivu-btn-success"
            @click="checkInvoice()"
          >
            Төлбөр шалгах
          </button>
        </div>
      </div>
      <div v-else>Таны мэдээлэл баталгаажаагүй байна.</div>
      <h4 v-if="hasPermission(['learningadmin'])">
        Өмнөх 3 буюу сүүлийн 18 сарын хугацаанд болсон шалгалтанд оролцсон тухай
      </h4>
      <table
        v-if="hasPermission(['learningadmin'])"
        class="table w-full table-god table-bordered"
        cellspacing="0"
      >
        <thead>
          <tr>
            <th>Бүртгэл</th>
            <th>Шалгалт</th>
            <th>Огноо</th>
            <th>Оролцсон эсэх</th>
            <th>Оноо</th>
            <th>Засах</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(exam, i) in lastExams" :key="i">
            <td>{{ exam.parentTask }}</td>
            <td>{{ exam.task }}</td>
            <td>{{ formatDateYMD(exam.dueStartDate, "-") }}</td>
            <td>
              <span v-if="exam.isJoined">Тийм</span>
              <span v-else>Үгүй</span>
            </td>
            <td>{{ exam.perc }}</td>
            <td>
              <InputNumber
                @on-change="changePerc($event, exam)"
                :active-change="false"
                v-model="exam.perc"
                :min="0"
                :max="100"
              ></InputNumber>
              <Button>
                <Icon type="ios-checkmark" />
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <b-modal
      :transition-names="[]"
      v-model="paymentVisible"
      title="Төлбөр төлөх"
    >
      <!-- <go-payment
        v-if="payInvoiceId>0"
        ref="gopymnt"
        :amount="1"
        :invcId="payInvoiceId"
        :hideBackBtn="false"
        @on-check-payment="payInvoice()"
        @on-payback="payBack()"
      ></go-payment>-->
    </b-modal>
  </span>
</template>
<script>
// import {
//   acceptInvoice,
//   getInvoiceWorkTasksByBoxId
// } from "@/api/modules/sys/bank";

// import { generate } from "@/api/modules/sys/qr";

// import QrcodeVue from "qrcode.vue";

// import { getSharedUserInfo } from "@/api/taskInUser";
// import { getLast3ExamPoint, setExamPointByUserId } from "@/api/learn";

import { getConfigValueByKey } from "@/libs/util";

// import {
//   taskInheritedDetail,
//   GetInheritedTask,
//   PostInheritedTask
// } from "@/api/project";

import { hasOneOf } from "@/libs/tools";

//import goPayment from "@/view/component/payment";
//import { Notice } from "iview";

import { request } from "@/api/all";

export default {
  components: {
    // QrcodeVue,
    // goPayment
  },
  props: {
    task: {},
    taskId: 0,
    btnTxt: {
      type: String,
      default: () => "Баталгаажуулах"
    }
  },
  data() {
    return {
      prntKey: 0,
      payInvoiceId: 0,
      paymentVisible: false,

      qrOption: {
        value: "",
        size: 120
      },
      examRegistrationTask: {},
      localTask: {},
      mdlShow: false,
      lastExams: [],
      selectedExams: [],
      profData: {},
      profDataRdy: false,
      bse64: "",
      profileModel: {},
      passperc: 0
    };
  },
  methods: {
    payBack() {
      //console.log("payback loaded")
      this.$refs.gopymnt.showQPay = false;
      this.$refs.gopymnt.lendQr.show = false;
      this.$refs.gopymnt.payMethod = 0;
      this.$refs.gopymnt.paymentCheckCount = 0;
    },
    // formatDateYMD(d, v) {
    //   return formatDateYMD(d, v);
    // },
    // formatDateHM(d) {
    //   return formatDateHM(d);
    // },
    getHighPoint(exam) {
      if (
        this.lastExams.filter(
          x => x.isJoined == true && x.locTypeId == exam.locTypeId
        ).length > 0
      ) {
        //console.log(this.lastExams.filter(x=>x.isJoined==true && x.locTypeId==exam.locTypeId).sort((a,b)=>a.perc>b.perc))
        let sorted = _.orderBy(
          this.lastExams.filter(
            x => x.isJoined == true && x.locTypeId == exam.locTypeId
          ),
          ["perc"],
          ["desc"]
        );
        if (sorted[0].perc >= this.passperc) return sorted[0].perc;
        else return "";
      } else {
        return "";
      }
    },
    getHighPointDate(exam) {
      if (
        this.lastExams.filter(
          x => x.isJoined == true && x.locTypeId == exam.locTypeId
        ).length > 0
      ) {
        //console.log(this.lastExams.filter(x=>x.isJoined==true && x.locTypeId==exam.locTypeId).sort((a,b)=>a.perc>b.perc))
        let sorted = _.orderBy(
          this.lastExams.filter(
            x => x.isJoined == true && x.locTypeId == exam.locTypeId
          ),
          ["perc"],
          ["desc"]
        );
        if (sorted[0].perc >= this.passperc) return sorted[0].dueStartDate;
        else return "";
      } else {
        return "";
      }
    },
    saveProfileData() {
      PostInheritedTask({ model: this.profileModel });
    },
    print() {
      var _content = this.$refs.printArea.innerHTML;
      var mywindow = window.open("", "Print", "height=600,width=800");

      mywindow.document.write("<html><head><title>Print</title>");
      mywindow.document.write(
        "</head><body> <style>.table-god thead tr th, .table-god tbody tr td {    vertical-align: middle;    border: 1px solid rgba(0, 0, 0, 0.05) !important;    font-weight: normal;    font-size: 10px;      padding: 4px 6px !important;   }        </style>"
      );
      mywindow.document.write(_content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },
    changePerc(e, exam) {
      //   setExamPointByUserId({
      //     taskId: exam.id,
      //     userId: this.task.userId,
      //     point: e
      //   })
      //learn/setExamPointByUserId
      request({
        api: {
          url: "learn/setExamPointByUserId",
          method: "get"
        },
        params: {
          taskId: exam.id,
          trackUserId: this.task.userId,
          point: e
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          exam.isJoined = true;
          exam.perc = e;
        }
      });
    },
    acceptInvoice(id) {
      acceptInvoice({ id: id });
      //Payment/acceptInvoice
      request({
        api: {
          url: "Payment/acceptInvoice",
          method: "post"
        },
        data: { id: id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.$bvToast.toast("Амжилттай Баталгаажлаа", {
            title: "Мэдэгдэл",
            autoHideDelay: 5000,
            appendToast: true
          });
          //Notice.success({ desc: "Баталгаажлаа." });
        }
      });
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    getSharedUserInfo() {
      //   getSharedUserInfo({
      //     taskId: this.localTask.thirdOrganizationTaskId,
      //     userId: this.localTask.userId
      //   })
      request({
        api: {
          url: "TaskInUser/GetSharedUserInfo",
          method: "get"
        },
        params: {
          taskId: this.localTask.thirdOrganizationTaskId,
          trackUserId: this.localTask.userId
        },
        store: this.$store
      }).then(res => {
        //console.log(res);
        this.profData = res.data.user;
        //console.log('profData', this.profData);

        // GetInheritedTask({
        //   id: this.profData.taskId
        // })
        request({
          api: {
            url: "task/GetInherited",
            method: "get"
          },
          params: {
            id: this.profData.taskId
          },
          store: this.$store
        }).then(resProfile => {
          if (resProfile != false) {
            this.profileModel = resProfile.data.task;
            this.profileModel.i3 = 1;
          }
        });

        this.qrOption.value =
          "http://core.gosmart.mn/user/card/?uid=" +
          this.profData.userId +
          "&gid=" +
          this.profData.gid +
          "&sh=" +
          this.profData.colorCls +
          "&checkTaskId=" +
          this.localTask.thirdOrganizationTaskId;

        //generate({ qr: this.qrOption.value })
        request({
          api: {
            url: "QR/Generate",
            method: "post"
          },
          data: {
            qr: this.qrOption.value
          },
          store: this.$store
        }).then(resQr => {
          if (resQr != false) {
            //console.log(resQr);
            this.profDataRdy = true;
            this.bse64 = "data:image/png;base64, " + resQr.data.base64;
          }
        });

        // setTimeout(() => {
        //     this.$nextTick(function(){
        //       var ctx = $("#qr_canvas")[0].children[0];
        //       //console.log('ctx', ctx);
        //       let _bse64= ctx.toDataURL("image/png").replace("image/png", "image/octet-stream");
        //console.log('_bse64', _bse64);
        //       this.bse64= _bse64;

        //       $('#qr_canvas').remove();
        //     })
        // }, 5000);
      });
    },
    pushNotContainedExams() {
      this.lastExams.forEach((exam, i) => {
        if (
          this.selectedExams.filter(x => x.locTypeId == exam.locTypeId)
            .length == 0
        ) {
          let fltrd = this.lastExams.filter(
            x => x.locTypeId == exam.locTypeId
          )[0];
          this.selectedExams.push({
            locTypeId: fltrd.locTypeId,
            task: fltrd.task,
            perc: 0
          });
        }
      });
    },
    checkInvoice() {
      this.paymentVisible = true;
    },
    payInvoice() {
      this.$refs.gopymnt.doPayment(this.payInvoiceId);
    },
    init() {
      let hdetmp = getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "onlineExamRegistration_passPerc"
      );
      if (hdetmp != undefined) {
        this.passperc = parseInt(hdetmp, 10);
      }
      request({
        api: { url: "learn/getLast3ExamPoint", method: "get" },
        params: { trackUserId: this.task.userId },
        store: this.$store
      }).then(res => {
        this.lastExams = res.data.tasks;
        if (this.task.b == undefined) {
          request({
            api: {
              url: "task/taskInheritedDetail",
              method: "get"
            },
            params: { id: this.taskId },
            store: this.$store
          }).then(res => {
            if (res != false) {
              this.localTask = res.data.task;
              this.payInvoiceId = this.localTask.id;
              request({
                api: {
                  url: "task/taskInheritedDetail",
                  method: "get"
                },
                params: {
                  id: this.localTask.thirdOrganizationTaskId,
                  requestFlag: 293
                },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  this.examRegistrationTask = res.data.task;
                  if (this.examRegistrationTask.objectTypeId == 340)
                    this.getSharedUserInfo();
                }
              });
              request({
                api: {
                  url: "Payment/getInvoiceWorkTasksByBoxId",
                  method: "get"
                },
                params: { boxId: this.localTask.b[0].id },
                store: this.$store
              }).then(res => {
                this.selectedExams = res.data.tasks;
                this.pushNotContainedExams();
              });
            }
          });
        } else {
          this.localTask = this.task;
          request({
            api: {
              url: "Payment/getInvoiceWorkTasksByBoxId",
              method: "get"
            },
            params: { boxId: this.task.b[0].id },
            store: this.$store
          }).then(res => {
            this.selectedExams = res.data.tasks;
            this.pushNotContainedExams();
          });
          this.getSharedUserInfo();
        }
      });

      this.mdlShow = true;
    },
    visibleChange(e) {
      if (!e) {
        this.prntKey++;
      }
    }
  }
};
</script>
